const { Filter } = require('pixi.js');

class LightBeamFilter extends Filter {
  constructor() {
    const vert = `
      attribute vec2 aVertexPosition;

      uniform mat3 projectionMatrix;
      
      varying vec2 vTextureCoord;
      
      uniform vec4 inputSize;
      uniform vec4 outputFrame;
      
      vec4 filterVertexPosition(void){
        vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;
        return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
      }
      
      vec2 filterTextureCoord(void) {
        return aVertexPosition * (outputFrame.zw * inputSize.zw);
      }
      
      void main(void) {
        gl_Position = filterVertexPosition();
        vTextureCoord = filterTextureCoord();
      }
    `;
    const frag = `
      varying vec2 vTextureCoord;

      uniform sampler2D uSampler;
      uniform float uProgress;

      void main(void) {
        vec4 color = texture2D(uSampler, vTextureCoord);
        float is = step(1.0 - vTextureCoord.y, uProgress);
        gl_FragColor = color * is;
      }
    `;
    super(vert, frag);

    this.uniforms.uProgress = 0;
  }

  get progress() {
    return this.uniforms.uProgress;
  }

  set progress(val) {
    this.uniforms.uProgress = val;
  }
}

export default LightBeamFilter;
